module.exports = __webpack_public_path__ + "img/9.618b0375.png";